module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"selected_kpis":"Selected KPIs({0})","apply":"Apply","cancel":"Cancel","requirement_alert":"Please, select as least 4 KPI!"}}')
  delete Component.options._Ctor
}
